import React, { useState, useEffect, Fragment } from "react";
import { Link } from "gatsby";
import Image from "gatsby-image";
import { getImage, getMetafield } from "~/helpers";
import {
  getCollectionMetafields,
  getShopMetafields,
} from "~/helpers/requests/metafield-requests";
import { HeadingLarge, Heading } from "~/components/.base/headings";
import { FlexBox, BackgroundDiv } from "~/components/.base/containers";
import { WhiteButton } from "~/components/.base/buttons";
import girl_eating_lobster from "~/images/collectionPage/girl_eating_lobster.png";
import lobster_sandwich from "~/images/collectionPage/lobster_sandwich.png";
import corner_lobster from "~/images/collectionPage/corner_lobster.png";
import blurry_lobster from "~/images/collectionPage/blurry_lobster.png";
import lobster_sandwich_mobile from "~/images/collectionList/lobster.jpg";
import girl_eating_lobster_mobile from "~/images/collectionList/family-meals.jpg";
import "./CollectionPageFooter.scss";
import { isMobileOnly } from "react-device-detect";

const CollectionPageFooter = ({ collectionImages, collectionHandle }) => {
  console.log(collectionImages);
  const [relatedCollOne, setRelatedCollOne] = useState(null);
  const [relatedCollTwo, setRelatedCollTwo] = useState(null);
  useEffect(() => {
    getCollectionMetafields(collectionHandle)
      .then((res) => {
        if (res.data && res.data.length) {
          const mfData = res.data.map((item) => item.node);
          console.log(mfData);
          console.log(getMetafield(mfData, "related_collection_1"));
          if (getMetafield(mfData, "related_collection_1")) {
            setRelatedCollOne({
              title: getMetafield(mfData, "related_collection_1_title"),
              handle: getMetafield(mfData, "related_collection_1"),
              image: getMetafield(mfData, "related_collection_1_image")
                ? JSON.parse(
                    getMetafield(mfData, "related_collection_1_image")
                  )[0]
                : lobster_sandwich,
            });
            console.log(
              JSON.parse(getMetafield(mfData, "related_collection_1_image"))
            );
          }
          if (getMetafield(mfData, "related_collection_2")) {
            setRelatedCollTwo({
              title: getMetafield(mfData, "related_collection_2_title"),
              handle: getMetafield(mfData, "related_collection_2"),
              image: getMetafield(mfData, "related_collection_2_image")
                ? JSON.parse(
                    getMetafield(mfData, "related_collection_2_image")
                  )[0]
                : girl_eating_lobster,
            });
          }
        }
      })
      .catch((err) => console.log(err));
  }, []);
  return (
    <>
      <div className="collection-page-footer">
        <HeadingLarge>
          Continue{" "}
          <span className="red">
            your
            <br />
            journey
          </span>
        </HeadingLarge>
        {isMobileOnly ? (
          <div className="mobile-footer">
            <div className="related-collections">
              {relatedCollOne ? (
                <Link to={`/collections/${relatedCollOne.handle}`}>
                  <div className="related-col-tile">
                    <img
                      src={relatedCollOne.image.src}
                      alt={relatedCollOne.title}
                    />
                    <WhiteButton>+</WhiteButton>
                    <Heading md="1rem auto 2rem">
                      {relatedCollOne.title}
                    </Heading>
                  </div>
                </Link>
              ) : (
                <Link to="/collections/lobster">
                  <div className="related-col-tile">
                    <Image
                      fluid={getImage(collectionImages, "lobster")}
                      alt="lobster meat"
                    />
                    <WhiteButton>+</WhiteButton>
                    <Heading md="1rem auto 2rem">Lobster</Heading>
                  </div>
                </Link>
              )}
              {relatedCollTwo ? (
                <Link to={`/collections/${relatedCollTwo.handle}`}>
                  <div className="related-col-tile">
                    <img
                      src={relatedCollTwo.image.src}
                      alt={relatedCollTwo.title}
                    />
                    <WhiteButton>+</WhiteButton>
                    <Heading md="1rem auto 2rem">
                      {relatedCollTwo.title}
                    </Heading>
                  </div>
                </Link>
              ) : (
                <Link to="/collections/entrees-sides">
                  <div className="related-col-tile">
                    <Image
                      fluid={getImage(collectionImages, "family-meals")}
                      alt="entrees and sides"
                    />
                    <WhiteButton>+</WhiteButton>
                    <Heading md="1rem auto 2rem">Entrees & sides</Heading>
                  </div>
                </Link>
              )}
            </div>
          </div>
        ) : (
          <>
            <BackgroundDiv left="0" top="-100px" z="1">
              <Image
                fluid={getImage(collectionImages, "blurry_lobster")}
                alt="blurry lobster"
              />
            </BackgroundDiv>
            <BackgroundDiv right="0" bottom="0" z="1">
              <Image
                fluid={getImage(collectionImages, "corner_lobster")}
                alt="lobster"
                className="corner-lobster"
              />
            </BackgroundDiv>
            <FlexBox justify="center" className="related-collections">
              {relatedCollOne ? (
                <Link to={`/collections/${relatedCollOne.handle}`}>
                  <div className="related-col-tile">
                    <img
                      src={relatedCollOne.image.src}
                      alt={relatedCollOne.title}
                    />
                    <WhiteButton>+</WhiteButton>
                    <Heading md="1rem auto 2rem">
                      {relatedCollOne.title}
                    </Heading>
                  </div>
                </Link>
              ) : (
                <Link to="/collections/lobster">
                  <div className="related-col-tile">
                    <Image
                      fluid={getImage(collectionImages, "lobster_sandwich")}
                      alt="lobster meat"
                    />
                    <WhiteButton>+</WhiteButton>
                    <Heading md="1rem auto 2rem">Lobster</Heading>
                  </div>
                </Link>
              )}
              {relatedCollTwo ? (
                <Link to={`/collections/${relatedCollTwo.handle}`}>
                  <div className="related-col-tile">
                    <img
                      src={relatedCollTwo.image.src}
                      alt={relatedCollTwo.title}
                    />
                    <WhiteButton>+</WhiteButton>
                    <Heading md="1rem auto 2rem">
                      {relatedCollTwo.title}
                    </Heading>
                  </div>
                </Link>
              ) : (
                <Link to="/collections/entrees-sides">
                  <div className="related-col-tile">
                    <Image
                      fluid={getImage(collectionImages, "girl_eating_lobster")}
                      alt="entrees and sides"
                    />
                    <WhiteButton>+</WhiteButton>
                    <Heading md="1rem auto 2rem">Entrees & sides</Heading>
                  </div>
                </Link>
              )}
            </FlexBox>
          </>
        )}
      </div>
    </>
  );
};

export default CollectionPageFooter;
